import React, { useContext, useEffect, useState } from "react";
import "../App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

// import {
//   Header,
//   Login,
//   Users,
//   UserForm,
//   Taxionomies,
//   TaxonomyForm,
//   Template,
//   TemplateForm,
//   Footer,
//   Privacy,
//   TermsAndC,
//   getProfileApi,
// } from "@11solutionspvtltd/eleven-solutions-common-website";

import Home from "../Components/pages/homepages/Home";
import About from "../Components/about/About";
import HeaderProjects from "../Components/projects/Projects";
import Donation from "../Components/donation/Donation";
import DonationHistory from "../Components/donation/DonationHistory";
import MadrasaETajushShariah from "../Components/projects/MadrasaETajushShariah";
import MadrasaETajushShariahLand from "../Components/projects/MadrasaETajushShariahLand";
import MasjidETajushShariah from "../Components/projects/MasjidETajushShariah";
import ScrollToTop from "./ScrollToTop";

import ProjectDetails from "../Components/projects/ProjectDetails";

import DigitalSupport from "../Components/projects/DigitalSupport";
import Announcement1 from "../Components/pages/announcement/Announcement1";
import Contact from "../Components/contacts/Contact";
import AdminSideBar from "../Components/admin/AdminSideBar";
import {
  setUserProfile,
  updateUserProfile,
} from "../Components/hooks/Redux/Slices/userProfileSlice";
import { ThemeContext } from "../Components/theme/ThemeProvider";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../Components/hooks/Redux/Redux";
import Cookies from "universal-cookie";
import BankStatement from "../Components/admin/bankstatement/BankStatement";

import { DonationDetails } from "../Components/admin/donationdetails/DonationDetails";
import { BankDetails } from "../Components/admin/BankDetails";
import { BankDetailsForm } from "../Components/admin/BankDetailsForm";
import { Expense } from "../Components/admin/Expense";
import { BalanceTransfer } from "../Components/admin/BalanceTransfer";
import { Box } from "../Components/admin/Box";
import { BoxForm } from "../Components/admin/BoxForm";

// import {
// Box,
// BoxForm,
// Expense,
// ExpenseForm,
// BalanceTransfer,
// BalanceTransferForm,
// BankDetailsForm,
// BankDetails,
// DonationTypePurpose,
// DonationTypePurposeForm,
// DonationDetails,
// DonationDetailForm,
// Project,
// ProjectForm,
// DonationType,
// PurposeType,
// EducationType,
// EducationTypeForm,
// Course,
// CourseForm,
// CourseType,
// CourseTypeForm,
// CourseOffering,
// CourseOfferingForm,
// Registration,
// RegistrationForm,
// StudentRegistration,
// SucessPage,
// Fee,
// ShowRegistration,
// } from "@11solutionspvtltd/eleven-solutions-trust-website";

import { EducationType } from "../Components/admin/Education/EducationType";
import { EducationTypeForm } from "../Components/admin/Education/EducationTypeForm";
import { CourseType } from "../Components/admin/Education/CourseType";
import { CourseTypeForm } from "../Components/admin/Education/CourseTypeForm";
import { Course } from "../Components/admin/Education/Course";
import { CourseForm } from "../Components/admin/Education/CourseForm";
import { CourseOffering } from "../Components/admin/Education/CourseOffering";
import { CourseOfferingForm } from "../Components/admin/Education/CourseOfferingForm";
import { Registration } from "../Components/admin/Education/Registration";
import { RegistrationForm } from "../Components/admin/Education/RegistrationForm";
import { Fee } from "../Components/Education/Fee";
import { ShowRegistration } from "../Components/Education/ShowRegistration";
import { StudentRegistration } from "../Components/Registration/StudentRegistration";
import { BatchForm } from "../Components/admin/Education/BatchForm";
import Batch from "../Components/admin/Education/Batch";
import EmployeeForm from "../Components/admin/Education/EmployeeForm";
import Employee from "../Components/admin/Education/Employee";
import { DonationTypePurpose } from "../Trust/components/DonationTypePurpose";
import { DonationTypePurposeForm } from "../Trust/components/DonationTypePurposeForm";
import { Project } from "../Trust/components/Project";
import { ProjectForm } from "../Trust/components/ProjectForm";
import { DonationType } from "../Trust/components/DonationType";
import { PurposeType } from "../Trust/components/PurposeType";
import { getProfileApi } from "../common/api/updateuser";
import { Header } from "../common/login/Header";
import { Login } from "../common/login/Login";
import { TermsAndC } from "../common/footer/Terms";
import { Privacy } from "../common/footer/Privacy";
import { Users } from "../common/components/Users";
import { UserForm } from "../common/components/UserForm";
import { Taxionomies } from "../common/components/Taxionomies";
import { TaxonomyForm } from "../common/components/TaxonomyForm";
import { Template } from "../common/components/Template";
import { TemplateForm } from "../common/components/TemplateForm";
import { Footer } from "../common/footer/Footer";
import Dashboard from "../common/components/Dashboard";

const clientId = process.env.REACT_APP_GOOGLE_CLIENTID as string;
const readyear = process.env.REACT_APP_READ_YEAR as string;

function AppRouter() {
  const location = useLocation();
  const userProfile = useAppSelector(
    (state: any) => state.userProfile.userData
  );
  const [userType] = useState(null);
  const [isLoading] = useState(false);
  const isAdminRoute = location.pathname.startsWith("/admin");
  const isAnnouncementRoute = location.pathname.startsWith("/announcement");
  const [iscloseModal, setclosemodal] = useState(true);
  const themeContext = useContext(ThemeContext);
  const isDarkMode = themeContext?.isDarkMode ?? false;
  const toggleTheme = themeContext?.toggleTheme ?? (() => { });
  const cookies = new Cookies();

  const [userLogedin, setUserLogedin] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const token = cookies.get("authToken");
  const [ModalOpen] = useState(true);
  const url: string = process.env.REACT_APP_API_URL!;
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const closeModal = () => {
    setclosemodal(!iscloseModal);
    navigate("/home");
  };

  const goToSupportUs = () => {
    const onHome = location.pathname === "/home";
    const onSupportHash = window.location.hash === "#donate";

    if (onHome && onSupportHash) {
      const target = document.getElementById("donate");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      return;
    }

    navigate("/home#donate");
  };

  useEffect(() => {
    if (token) {
      setUserLogedin(true);
      const fetchProfile = async () => {
        try {
          const actualToken =
            typeof token === "object" && token.data ? token.data.token : token;

          const response = await getProfileApi(actualToken, url);
          setUserDetails(response);
          if (response) {
            dispatch(setUserProfile(response));
          }
        } catch (error) { }
      };

      fetchProfile();
    }
  }, [dispatch, token, url]);

  useEffect(() => {
    if (location.pathname === "/login") {
      if (userProfile) {
        setclosemodal(false);
      } else {
        setclosemodal(true);
      }
    }
  }, [location.pathname, userProfile]);
  if (isLoading) {
    return (
      <div className="flex items-center justify-center">
        <div
          className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
          role="status"
        >
          <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
            Loading...
          </span>
        </div>
      </div>
    );
  }

  const menugroups = [
    {
      label: "Projects",
      path: "/projects",
      onClick: () => navigate("/projects"),
    },
    {
      label: "Donate",
      path: "/home#donate",
      onClick: goToSupportUs,
    },
  ];
  const donationHistory = {
    label: "Donation History",
    onClick: () => navigate("/donation-history"),
  };


  return (
    <>
      {!isAdminRoute && !isAnnouncementRoute && (
        <Header
          toggleTheme={toggleTheme}
          isDarkMode={isDarkMode}
          userLogedin={userLogedin}
          userType={userType}
          url={url}
          img={"images/TFLogo.svg"}
          name="TajushShariah Foundation"
          userdetails={userDetails}
          menugroups={menugroups}
          donationHistory={donationHistory}
        />
      )}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Home />} />
        <Route path="/announcement1" element={<Announcement1 />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<HeaderProjects />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/donate" element={<Donation url={url} />} />
        <Route
          path="jrm/online/registration"
          element={
            <StudentRegistration
              isDarkMode={isDarkMode}
              url={url}
              updateUserProfile={updateUserProfile}
              useDispatch={useDispatch}
              useAppSelector={useAppSelector}
            />
          }
        />
        <Route
          path="/Education/Fee"
          element={<Fee url={url} isDarkMode={isDarkMode} />}
        />
        <Route
          path="/Education/Registration"
          element={<ShowRegistration url={url} isDarkMode={isDarkMode} />}
        />
        <Route path="/donation-history" element={<DonationHistory />} />
        <Route
          path="/login"
          element={
            iscloseModal ? (
              <Login
                closeModal={closeModal}
                isDarkMode={isDarkMode}
                url={url}
                ModalOpen={ModalOpen}
                img={"images/TFLogo.svg"}
              />
            ) : (
              <Home />
            )
          }
        />
        <Route path="/contact" element={<Contact />} />
        <Route
          path="/MadrasaETajushShariah"
          element={<MadrasaETajushShariah />}
        />
        <Route
          path="MadrasaETajushShariahLand"
          element={<MadrasaETajushShariahLand />}
        />
        <Route
          path="/MasjidETajushShariah"
          element={<MasjidETajushShariah />}
        />
        <Route path="/ProjectDetails" element={<ProjectDetails />} />
        <Route path="/DigitalSupport" element={<DigitalSupport />} />
        <Route
          path="/termsandconditions"
          element={<TermsAndC isDarkMode={isDarkMode} />}
        />
        <Route
          path="/privacyandpolicy"
          element={<Privacy isDarkMode={isDarkMode} />}
        />
        <Route
          path="DonationTypePurpose"
          element={<DonationTypePurpose url={url} />}
        />

        {userProfile?.roleType === 2 ? (
          <Route path="/admin" element={<AdminSideBar />}>
            <Route index element={<Dashboard />} />
            <Route
              path="RegistrationForm"
              element={<RegistrationForm url={url} />}
            />
            <Route
              path="Expense"
              element={
                <Expense
                  url={url}
                  readyear={readyear}
                  isDarkMode={isDarkMode}
                />
              }
            />
            <Route path="users" element={<Users url={url} />} />
            <Route path="project" element={<Project url={url} />} />
            <Route path="projectform" element={<ProjectForm url={url} />} />
            <Route path="users/userform" element={<UserForm url={url} userId={""} onClose={function (): void {
              throw new Error("Function not implemented.");
            }} />} />
            <Route path="taxinomies" element={<Taxionomies url={url} />} />
            <Route path="template" element={<Template url={url} />} />
            <Route
              path="template/templateform"
              element={<TemplateForm url={url} />}
            />
            <Route path="box" element={<Box url={url} />} />
            <Route
              path="BalanceTransfer"
              element={
                <BalanceTransfer
                  url={url}
                  readyear={readyear}
                  isDarkMode={isDarkMode}
                />
              }
            />
            <Route path="BankDetails" element={<BankDetails url={url} />} />
            <Route
              path="DonationTypePurpose"
              element={<DonationTypePurpose url={url} />}
            />
            <Route
              path="DonationDetails"
              element={
                <DonationDetails
                  url={url}
                  isDarkMode={isDarkMode}
                  readyear={readyear}
                />
              }
            />
            <Route path="Course" element={<Course url={url} />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="CourseType" element={<CourseType url={url} />} />
            <Route
              path="CourseOffering"
              element={<CourseOffering url={url} />}
            />
            <Route path="EducationType" element={<EducationType url={url} />} />
            <Route
              path="BankStatement"
              element={<BankStatement url={url} readyear={readyear} />}
            />
            <Route path="Registration" element={<Registration url={url} />} />
            <Route path="Batch" element={<Batch url={url} />} />
            <Route path="Employee" element={<Employee url={url} />} />
            <Route path="DonationType" element={<DonationType url={url} />} />
            <Route path="PurposeType" element={<PurposeType url={url} />} />
          </Route>
        ) : null}
      </Routes>
      {!isAdminRoute && !isAnnouncementRoute && (
        <Footer
          isDarkMode={isDarkMode}
          companyName={"Eleven Software Solutions Pvt.Ltd"}
          name="TajushShariah Foundation"
          img="images/TFLogo.svg"
        />
      )}
    </>
  );
}
function Router() {
  return (
    <BrowserRouter>
      <GoogleOAuthProvider clientId={clientId}>
        <AppRouter />
      </GoogleOAuthProvider>
    </BrowserRouter>
  );
}

export default Router;
